import styled from 'styled-components';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import { Link } from 'react-router-dom';
import { StyledWrapper } from '../common/Wrapper/Wrapper.styles';
import media from '../../styles/config/mediaQueries';

const StyledContainer = styled.section`
  width: 100%;
  border-bottom: 1px solid ${theme.color.white100};
  ${media.mobile`
    padding: 59px 0 25px;
  `}
  ${media.desktop`
    padding: 41px 0 56px;
  `}

  ${StyledWrapper} {
    ${media.desktop`
      display: flex;
    `}
  }
`;

const StyledTextContainer = styled.div`
  ${media.desktop`
    max-width: 360px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  `}
`;

const StyledSubtitle = styled.h3`
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 2px;
  opacity: 0.7;
  text-transform: uppercase;
`;

const StyledHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${media.mobile`
    margin-bottom: 10px;
  `}
  ${media.desktop`
    width: 100%;
    margin-bottom: 8px;
  `}
`;

const StyledTitle = styled.h2`
  ${typeStyle.h1}
`;

const StyledLike = styled.button`
  position: relative;
  width: 26px;
  height: 26px;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 90%;
    height: 90%;
    transform: translate(-50%, -50%);
  }
`;

const StyledImageContainer = styled.div`
  text-align: center;
  ${media.mobile`
    width: 100%;
    margin-bottom: 15px;
    padding: 35px 0;
  `}
  ${media.desktop`
    width: 300px;
    height: 375px;
    margin-left: auto;
  `}

  img {
    display: inline-block;
    ${media.mobile`
      width: 144px;
    `}
    ${media.desktop`
      width: 100%;
    `}
  }
`;

const StyledDescription = styled.p`
  ${typeStyle['font-14']}
  margin-bottom: 16px;
  ${media.desktop`
    margin: auto 0 0;
  `}
`;

const StyledLink = styled(Link)`
  ${typeStyle['font-14']}
  text-transform: uppercase;
  padding-bottom: 12px;
  position: relative;
  ${media.desktop`
    margin: auto 0 0 ;
  `}

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 75px;
    height: 1px;
    background-color: ${theme.color.white};
  }
`;

export {
  StyledContainer,
  StyledSubtitle,
  StyledHeading,
  StyledTitle,
  StyledLike,
  StyledImageContainer,
  StyledDescription,
  StyledLink,
  StyledTextContainer,
};
